import React from "react";
import NavBar from "./NavBar";
import classes from "./Header.module.css";

const Header = () => {
  return (
    <header className={classes.headerContainer}>
      <div className={classes.imgContainer}></div>
      <div className={classes.mainHeader}>
        <h1 className={classes.pageTitle}>
          Partial Retirement Remedy Benefits Illustrator
        </h1>
        <NavBar />
      </div>
      <div className={classes.imgContainer}></div>
    </header>
  );
};

export default Header;
